<mat-dialog-content class="fullscreen-dialog">
  <mat-toolbar class="fullscreen-toolbar" color="primary">
    Confirm Recall
  </mat-toolbar>
  <div class="container">
    <br />
    <p>Recall this ticket? The operative will be notified to stop work and the ticket will be returned to planning.</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="dialogRef.close(false)" mat-flat-button
          type="button">{{ 'scheduler.general.cancel' | translate }}
  </button>
  <button (click)="dialogRef.close(true)" color="warn" mat-flat-button
          type="button">Recall
  </button>
</mat-dialog-actions>
